<template lang="pug">
  .select-area
    h4.title 請先選擇區域
    .row
      .area-wrap.col-md-6.col-md-push-3
        .select-marked(:style="{maxWidth: (column * 50) + 'px'}")
          h4 區域標誌
          p(style="color:#868686; font-size:14px;") ＊區域標誌的遊戲名只是建議喜愛該遊戲玩家可選購此區，並非強制此區域內玩家只能玩該款遊戲喔！＊
          .marked.silent
            .icon
            .text 潛水區
          .marked.integrated
            .icon
            .text 綜合遊戲區
          .marked.steam
            .icon
            .text Steam區
          .marked.lol
            .icon
            .text 英雄聯盟區
          .marked.fps
            .icon
            .text 射擊遊戲區
          .marked.blizzard
            .icon
            .text 暴雪遊戲區
          .marked.warfare
            .icon
            .text 戰史遊戲區
          .marked.home
            .icon
            .text 無限制區
      .area-wrap.col-md-12
        .triger-row
          .stage: img(src="~assets/stage.png")
        .triger-row
          .triger-wrap(v-for="area in getArea", :class="areaClass(area)", @click="submitArea(area.section)")
            .desc-wrap
              div 共 {{ area.count }} 個
              //- div 剩餘 {{ area.remain_count }} 個
        .mb-30
    //- hr
    //- .btn-wrap
      .btn.ghost-btn.next-btn(@click="submitArea", href="#", :disabled="!selected") 下一步
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'selectArea',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log('isLogin: ', vm.isLogin)
      vm.fetchArea()
    })
  },
  props: {
    isLogin: {
      type: Boolean
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  computed: {
    ...mapGetters([
      'getArea',
      'getUser'
    ])
  },
  mounted () {
  },
  updated () {
    console.log('isLogin: ', this.isLogin)
  },
  methods: {
    ...mapActions([
      'fetchArea',
      // 'fetchRegistered',
      // 'fetchPayment',
      'saveSelectedArea'
    ]),
    submitArea (area) {
      this.selected = area
      if (this.selected) {
        this.saveSelectedArea(this.selected).then(() => {
          this.$router.push({name: 'selectSeats'})
        })
      }
    },
    areaClass (area) {
      if (area.section === 'A') {
        if (this.selected === 'A') {
          return 'areaA actived'
        }
        return 'areaA'
      }
      if (area.section === 'B') {
        if (this.selected === 'B') {
          return 'areaB actived'
        }
        return 'areaB'
      }
      if (area.section === 'C') {
        if (this.selected === 'C') {
          return 'areaC actived'
        }
        return 'areaC'
      }
      if (area.section === 'D') {
        if (this.selected === 'D') {
          return 'areaD actived'
        }
        return 'areaD'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/components'
.triger-row
  text-align: center
  width: 100%
  max-width: 450px
  margin: 0 auto
  .stage
    margin-bottom: 16px
  .triger-wrap
    position: relative
    display: inline-block
    margin: 8px
    cursor: pointer
    +transition(all, 0.3s, ease)
    &.areaA
      width: 201px
      height: 274px
      background-image: url('~assets/areaA.png')
      &:hover
        background-image: url('~assets/areaA-hover.png')
      &.actived
        background-image: url('~assets/areaA-actived.png')
    &.areaB
      width: 210px
      height: 274px
      background-image: url('~assets/areaB.png')
      &:hover
        background-image: url('~assets/areaB-hover.png')
      &.actived
        background-image: url('~assets/areaB-actived.png')
    &.areaC
      width: 201px
      height: 296px
      background-image: url('~assets/areaC.png')
      &:hover
        background-image: url('~assets/areaC-hover.png')
      &.actived
        background-image: url('~assets/areaC-actived.png')
    &.areaD
      width: 210px
      height: 296px
      background-image: url('~assets/areaD.png')
      &:hover
        background-image: url('~assets/areaD-hover.png')
      &.actived
        background-image: url('~assets/areaD-actived.png')
    .desc-wrap
      position: absolute
      bottom: 24px
      left: 50%
      font-size: 15px
      font-weight: bold
      line-height: 160%
      transform: translateX(-50%)
.select-marked
  margin: 32px auto 128px auto
  @extend %clearfix
  .marked
    margin: 8px 12px 0 0
    float: left
    border: 1px solid $grey
    padding: 6px 6px
    @extend %clearfix
    .icon
      width: 24px
      height: 24px
      margin: 0 6px 0 0
      display: block
      position: relative
      float: left
      &:after
        content: ''
        opacity: 0.8
        top: 0
        left: 0
        bottom: 0
        right: 0
        position: absolute
        z-index: 2
        background:
          position: center center
          repeat: no-repeat
          image: url('~assets/seat-available.png')
          size: 80%
    .text
      float: left
      font-size: 14px
      margin-top: 3px
    &.silent .icon
      background-color: #8470ad
    &.integrated .icon
      background-color: #93a733
    &.steam .icon
      background-color: #27d390
    &.lol .icon
      background-color: #b1aa8f
    &.fps .icon
      background-color: #d37c36
    &.blizzard .icon
      background-color: #198e99
    &.warfare .icon
      background-color: #a7344a
    &.home .icon
      background-color: #daa344
</style>



// WEBPACK FOOTER //
// selectArea.vue?53818c8e